import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import thunk from 'redux-thunk'
import createHistory from 'history/createBrowserHistory'
import { reactReduxFirebase, firebaseReducer } from 'react-redux-firebase'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'

const config = require('./config').default

// /* Firebase Redux Config */
const firebaseConfig = config.firebase

const rrfConfig = {
  userProfile: 'users',
}

window.firebase = firebase
firebase.initializeApp(firebaseConfig)
firebase.auth().useDeviceLanguage()

const createStoreWithFirebase = compose(
  reactReduxFirebase(firebase, rrfConfig), // firebase instance as first argument
  // reduxFirestore(firebase) // <- needed if using firestore
)(createStore)

export const history = createHistory()

const initialState = {}
const enhancers = []
const middleware = [thunk, routerMiddleware(history)]

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers,
)

const rootReducer = combineReducers({
  firebase: firebaseReducer,
  router: routerReducer,
  // firestore: firestoreReducer // <- needed if using firestore
})

const store = createStoreWithFirebase(rootReducer, initialState, composedEnhancers)

export default store



// WEBPACK FOOTER //
// ./src/store.js